import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Home, Trophy, User, Dumbbell } from 'lucide-react';
import { motion } from 'framer-motion';
export function StudentLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const navItems = [{
    id: '/student/home',
    icon: Home,
    label: 'Início'
  }, {
    id: '/student/hall-of-fame',
    icon: Trophy,
    label: 'Hall'
  }, {
    id: '/student/profile',
    icon: User,
    label: 'Perfil'
  }];
  return <div className="min-h-screen bg-gray-50 pb-20 md:pb-0 md:pl-64" data-id="element-121">
      {/* Mobile Header */}
      <header className="bg-white p-4 sticky top-0 z-20 shadow-sm md:hidden flex items-center justify-between" data-id="element-122">
        <div className="flex items-center gap-2" data-id="element-123">
          <div className="bg-[var(--primary)] p-1.5 rounded-lg text-white" data-id="element-124">
            <Dumbbell size={20} data-id="element-125" />
          </div>
          <span className="font-bold text-lg text-[var(--secondary)]" data-id="element-126">
            Iron Gym
          </span>
        </div>
        <div className="h-8 w-8 bg-gray-200 rounded-full overflow-hidden" data-id="element-127">
          <img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="User" data-id="element-128" />
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-md mx-auto md:max-w-4xl p-4" data-id="element-129">
        <Outlet data-id="element-130" />
      </main>

      {/* Bottom Navigation (Mobile) */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-6 py-3 flex justify-between items-center z-30 md:hidden pb-safe" data-id="element-131">
        {navItems.map(item => {
        const isActive = location.pathname === item.id;
        const Icon = item.icon;
        return <button key={item.id} onClick={() => navigate(item.id)} className={`flex flex-col items-center gap-1 transition-colors ${isActive ? 'text-[var(--primary)]' : 'text-gray-400'}`} data-id="element-132">
              <div className="relative" data-id="element-133">
                <Icon size={24} strokeWidth={isActive ? 2.5 : 2} data-id="element-134" />
                {isActive && <motion.div layoutId="navIndicator" className="absolute -bottom-2 left-1/2 w-1 h-1 bg-[var(--primary)] rounded-full transform -translate-x-1/2" data-id="element-135" />}
              </div>
              <span className="text-[10px] font-medium" data-id="element-136">{item.label}</span>
            </button>;
      })}
      </nav>

      {/* Desktop Sidebar (Placeholder for future responsive expansion) */}
      <aside className="hidden md:flex flex-col fixed left-0 top-0 bottom-0 w-64 bg-white border-r border-gray-200 p-6" data-id="element-137">
        <div className="flex items-center gap-2 mb-10" data-id="element-138">
          <div className="bg-[var(--primary)] p-2 rounded-lg text-white" data-id="element-139">
            <Dumbbell size={24} data-id="element-140" />
          </div>
          <span className="font-bold text-xl text-[var(--secondary)]" data-id="element-141">
            Iron Gym
          </span>
        </div>

        <nav className="space-y-2" data-id="element-142">
          {navItems.map(item => {
          const isActive = location.pathname === item.id;
          const Icon = item.icon;
          return <button key={item.id} onClick={() => navigate(item.id)} className={`flex items-center gap-3 w-full p-3 rounded-lg transition-colors ${isActive ? 'bg-orange-50 text-[var(--primary)] font-medium' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-143">
                <Icon size={20} data-id="element-144" />
                <span data-id="element-145">{item.label}</span>
              </button>;
        })}
        </nav>
      </aside>
    </div>;
}